class ProductGallerySlider extends HTMLElement {
  constructor() {
    super();

    let options = {
      imagesLoaded: true,
      contain: true,
      prevNextButtons: false,
      fade: true,
      wrapAround: true
    };

    const slider = new Flickity(this, options);

    slider.on("change", (selected_index) => {
      play_and_pause_videos(selected_index);
    });

    document.addEventListener("productgallerythumbnails:click", (event) => {
      slider.select(event.detail.index);
    });

    document.addEventListener("productformvariants:change", (event) => {
      slider.cells.forEach((cell, index) => {
        if (cell.element.dataset.variantId.includes(event.detail.variant.id)) {
          slider.select(index);
        }
      });
    });

    if (Theme.URLParams.has("variant")) {
      slider.cells.forEach((cell, index) => {
        if (cell.element.dataset.variantId.includes(Theme.URLParams.get("variant"))) {
          slider.select(index);
        }
      });
    }

    function play_and_pause_videos(selected_index) {
      slider.getCellElements().forEach((element, element_index) => {
        const video = element.querySelector("video");

        if (!video) {
          return;
        }

        if (selected_index == element_index) {
          video.play();
        } else {
          video.pause();
        }
      });
    }
  }
}

customElements.define("product-gallery-slider", ProductGallerySlider);

class ProductGalleryThumbnails extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      const link = event.target.closest("a");

      if (!link) {
        return;
      }

      event.preventDefault();

      document.dispatchEvent(new CustomEvent("productgallerythumbnails:click", {
        detail: {
          index: link.dataset.index
        }
      }));
    });
  }

  connectedCallback() {
    const wrap = this.parentElement;

    if (!wrap) {
      return;
    }

    const button_up = wrap.querySelector('.product-gallery-thumbnails-button[data-direction="up"]');
    const button_down = wrap.querySelector('.product-gallery-thumbnails-button[data-direction="down"]');

    if (button_up) {
      button_up.addEventListener("click", () => this.scrollByPage(-1));
    }

    if (button_down) {
      button_down.addEventListener("click", () => this.scrollByPage(1));
    }
  }

  scrollByPage(direction) {
    this.scrollBy({
      top: direction * this.clientHeight * 0.8,
      behavior: "smooth"
    });
  }
}

customElements.define("product-gallery-thumbnails", ProductGalleryThumbnails);